import PostRegistrationVirtualBox from './PostRegistrationVirtualBox';

export default PostRegistrationVirtualBox;
